export default "__VITE_ASSET__DOyGLLLo__"